import { useAddToCartButtonContext } from '@sharedComponents/AddToCartButton/context';

import { useUserProductsInfo } from './useUserProductsInfo';

export const useIsComparisonPrice = (masterId: string | number): boolean => {
  const userProductsInfo = useUserProductsInfo(masterId);
  const {
    state: { product },
  } = useAddToCartButtonContext();

  const singleMasterId = product?.masterId || '';

  return userProductsInfo?.some(
    (info) => info.productId === singleMasterId && info.isComparison
  );
};
